<template>
    <v-row>
        <v-col cols="12" md="8" class="d-md-flex justify-center justify-md-space-between">
            <city-airport-autocomplete
                ref="firstLocation"
                v-model="locations.from"
                single-line
                filled
                label="departure_location"
                :rules="[v => !!v || `${$t('departure_location')} ${$t('validation.required')}`]"
                :default-cities="[]"
                class="flex-grow-1 location-field"
            />
            <div class="text-center swap-btn">
                <v-btn
                    :icon="isMobile ? 'mdi-swap-vertical-bold' : 'mdi-swap-horizontal-bold'"
                    variant="text"
                    @click="swapLocations"
                />
            </div>
            <city-airport-autocomplete
                ref="secondLocation"
                v-model="locations.to"
                single-line
                filled
                label="arrival_location"
                :rules="[v => !!v || `${$t('arrival_location')} ${$t('validation.required')}`]"
                :default-cities="[]"
                class="flex-grow-1 location-field"
            />
        </v-col>
        <v-col cols="12" md="4">
            <daterange-m
                product="flights"
                :_start="startDate"
                :_end="endDate"
                @change-start="startDate = $event"
                @change-end="endDate = $event"
            />
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import CityAirportAutocomplete from '~/components/flights/search/forms/CityAirportAutocomplete.vue'
    import {FlightSearchFormMixin} from '~/mixins/Flights/FlightSearchFormMixin.vue'
    import DaterangeM from '~src/components/search/forms/daterangeM.src'

    @Component({
        components: {
            CityAirportAutocomplete,
            DaterangeM,
        },
    })
    export class RoundTrip extends mixins(FlightSearchFormMixin) {
        startDate = null
        endDate = null

        getRoutes() {
            return [
                {
                    departure: this.locations.from,
                    arrival: this.locations.to,
                    date: this.startDate,
                },
                {
                    departure: this.locations.to,
                    arrival: this.locations.from,
                    date: this.endDate,
                },
            ]
        }

        initDates() {
            if (
                flightsRuntimeStore.routes[0] &&
                flightsRuntimeStore.routes[1] &&
                this.$dateFns.isAfter(this.$dateFns.parseISO(flightsRuntimeStore.routes[0].date), new Date())
            ) {
                this.startDate = flightsRuntimeStore.routes[0].date
                this.endDate = flightsRuntimeStore.routes[1].date
            } else {
                this.startDate = this.$dateFns.format(this.$dateFns.addDays(new Date(), 1))
                this.endDate = this.$dateFns.format(this.$dateFns.addDays(new Date(), 7))
            }
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default RoundTrip
</script>

<style lang="scss" scoped>
    @use 'vuetify/settings';
    @use 'sass:map';

    @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
        .location-field {
            flex-basis: 100%;
        }
    }
</style>
